import { render, staticRenderFns } from "./PlayerFirstPlaces.vue?vue&type=template&id=181fa09e&"
import script from "./PlayerFirstPlaces.vue?vue&type=script&lang=js&"
export * from "./PlayerFirstPlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports